import React from 'react';
import Spinner from '../../Spinner';
import styles from './ReviewModal.module.scss';

export default function LoadingOverlay() {
  return (
    <div className={styles.loadingOverlay}>
      <Spinner color="blue" />
    </div>
  );
}
